import { render, staticRenderFns } from "./PerformsReportComponent.vue?vue&type=template&id=6f92df6e&scoped=true"
import script from "./PerformsReportComponent.vue?vue&type=script&lang=js"
export * from "./PerformsReportComponent.vue?vue&type=script&lang=js"
import style0 from "./PerformsReportComponent.vue?vue&type=style&index=0&id=6f92df6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f92df6e",
  null
  
)

export default component.exports